import {Alert} from '@material-ui/lab'
import {useDispatch, useSelector} from 'react-redux'
import {RouteComponentProps} from 'react-router-dom'
import SingleUser from 'src/components/SingleUser'
import User from 'src/models/User'
import {RootState} from 'src/redux/rootReducer'
import {actions as UserActions} from 'src/redux/modules/users'
import {useEffect, useState} from 'react'

export type TParams = {userID: string}

export type UserEditProps = RouteComponentProps<TParams> & {}

const UserEdit: React.FC<UserEditProps> = ({match, history}: UserEditProps) => {
  const [isSaving, setIsSaving] = useState<boolean>(false)
  const [isSuccess, setIsSuccess] = useState<boolean>(false)
  const {users, dataState} = useSelector((state: RootState) => state.users)

  const dispatch = useDispatch()

  let invalidID = !match.params || !match.params.userID

  let user = undefined
  if (!invalidID) {
    // Get the user ID back from the match.
    const userIDString = match.params.userID

    // Find the user with this ID.
    user = users.find((u: User) => u.id === userIDString)
  }

  // When the user clicks save, and the single-user form has verified the data, we
  // come back here.
  const onSaveUser = (updatedUser: User) => {
    // Save the user.
    dispatch(UserActions.saveUser({user: updatedUser}))

    // Set the flag
    setIsSaving(true)
  }

  const onCancelUser = () => {
    // Back to the users page.
    history.goBack()
  }

  useEffect(() => {
    if (isSaving && dataState.state !== 'loading') {
      // Finished saving.
      setIsSaving(false)

      if (!dataState.error) {
        // And no error!
        setIsSuccess(true)
      }
    }
  }, [isSaving, dataState, history])

  invalidID = invalidID || !user

  if (invalidID) {
    return <Alert severity="error">Invalid UserID.</Alert>
  } else {
    return (
      <SingleUser
        onSaveUser={onSaveUser}
        onCancel={onCancelUser}
        onDismissSuccess={() => history.goBack()}
        title="Edit User"
        isBusy={dataState.state === 'loading'}
        errorMessage={dataState.error?.message}
        editUser={user}
        isSuccess={isSuccess}
      />
    )
  }
}

export default UserEdit
